import script from "./PubHeroSplitBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PubHeroSplitBanner.vue?vue&type=script&setup=true&lang=js"

import "./PubHeroSplitBanner.vue?vue&type=style&index=0&id=0edbab4c&lang=scss"

const __exports__ = script;

export default __exports__